import { chainsRoutesConfig } from 'domains/chains/routes';
import { useAuth } from 'modules/auth/hooks/useAuth';

import { isFromProductsPage } from '../utils/isFromProductsPage';

const { useParams: useChainPageParams } = chainsRoutesConfig.chainDetails;

export const useShouldSignInFromChainPage = () => {
  const { authToken } = useAuth();

  const { chainId: chainID } = useChainPageParams();

  const hasAuthToken = Boolean(authToken);

  const shouldSignIn = isFromProductsPage({ chainID }) && !hasAuthToken;

  return shouldSignIn;
};
